const EventBus = window.VueEventBus
import {Vue} from '~/addiesaas'
import * as types from '../mutation-types/giftcard'
import config from '../../lib/config'
import { mapActions } from 'vuex';

const {
  products,
  clubspeed: {
    taxes,
    settings: {giftCard: {email: giftCardEmail} = {}} = {}
  },
} = config

// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'giftcard'

const cartItem = {
  id: '',
  name: '',
  groupTitle: '',
  title: '',

  amount: 0,
  tax: 0,
  rate: 0,
  quantity: 1,

  description: '', // can be a function

  editable: true,
  deletable: true,

  parent: '',
  children: [''],
  onEdit: function () {
  },
  onDelete: function () {
  },
  onAdd: function () {
  },
  type: 'giftcard',

  subItems: [],
  showSubItems: false,
  showSubItemTitle: false,
  showSubItemAmount: false,
  showSubItemHeader: false,
  showSubItemQuantity: false,
  showSubItemRate: false,
  attributes: {},
}

const helpers = {
  createCardItem(inputs, state, getters) {
    if (!inputs.cardReadyForCart) {
      return {}
    }

    const product = getters.selectedGiftCard
    const cartItemId = inputs.cartId || helpers.genCartItemId(cartItem.type, inputs, state, getters)
    const description = helpers.getDescription(inputs, product)

    let contact = {
      first_name: inputs.firstName,
      last_name: inputs.lastName,
      phone: inputs.phone,
      email: inputs.email
    }
    let recipient_email = null
    let recipient = null
    if (inputs.giftee) {
      recipient_email = inputs.gifteeEmail
      contact = recipient = {
        first_name: inputs.gifteeFirstName,
        last_name: inputs.gifteeLastName,
        phone: inputs.gifteePhone,
        email: inputs.gifteeEmail,
      }
    }

    const item = {
      id: cartItemId,
      title: product.title,
      type: 'gift_cards',
      total: product.price,
      groupTitle: 'Gift Cards',
      payload: {
        product_id: product.id,
        options: {
          recipient_email,
          recipient,
          inputs: {
            ...inputs,
            cartId: cartItemId
          },
          contact
        }
      },
      editable: true,
      attributes: {
        description,
        product,
        inputs: {
          ...inputs,
          cartId: cartItemId
        },
      }
    }

    return item
  },
  getDescription(inputs, product) {
    const {firstName, lastName, email, phone, giftee, gifteeFirstName, gifteeLastName, gifteeEmail, gifteePhone } = inputs
    if (giftee) {
      const rName = [gifteeFirstName || firstName, gifteeLastName || lastName].join(' ')
      const rEmail = gifteeEmail || email
      const rPhone = gifteePhone || phone
      return `<div class="m-b-5"><strong>Recipient</strong></div>
        <div>${rName}</div>
        <div>${rEmail}</div>
        <div>${rPhone}</div>
        `
    } else {
      return 'For myself'
    }
  },
  genCartItemId(type, inputs, state, getters) {
    return _.filter([type, inputs.productId, (new Date()).valueOf(), _.uniqueId()]).join('_')
  }
}

const { products: {types: {giftcard : giftCardProducts = []} = {}} = {}} = config
const giftCards = _.keyBy(giftCardProducts.filter(x => !('hidden' in (x.custom || {}))).map(x => Object.assign(x, { productId: x.id })), 'id')

// state
const state = {
  editItem: null,
  previewMode: false,
  cartItems: {},
  products: giftCards,
  form: Object.assign({}, {
      cartId: null,
      productId: '',
      cardNumber: '#000 000 000 0000',
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      giftee: '',
      gifteeFirstName: '',
      gifteeLastName: '',
      gifteeEmail: '',
      gifteePhone: '',
      giftNote: '',
      cardReadyForCart: false
    },
  ),
  wasCarted: false
}

// mutations
const mutations = {
  [types.SHOW_PREVIEW](state) {
    state.previewMode = true
  },
  [types.HIDE_PREVIEW](state) {
    state.previewMode = false
  },
  [types.SET_EDIT_ITEM](state, item) {
    Vue.set(state, 'editItem', item)
  },
  [types.SET_CARTED](state) {
    Vue.set(state, 'wasCarted', true)
  },
  [types.SET_INPUT](state, inputs) {
    _.forOwn(inputs, (value, key) => {
      Vue.set(state.form, key, value)
    })
  },
  [types.SET_LOCAL_CART_ITEM](state, item) {
    Vue.set(state.cartItems, item.id || item.cartId, item)
  },
  [types.UNSET_LOCAL_CART_ITEM](state, item) {
    Vue.delete(state.cartItems, item.id || item.cartId)
  },
  [types.CLEAR_LOCAL_CART_ITEMS](state) {
    Vue.set(state, 'cartItems', {})
  },
}

//actions
const actions = {
  showGiftCardPreview({commit}) {
    commit(types.SHOW_PREVIEW)
  },
  hideGiftCardPreview({commit}) {
    commit(types.HIDE_PREVIEW)
  },
  setGiftCardEditItem({commit}, payload) {
    commit(types.SET_EDIT_ITEM, payload)
  },
  setGiftCardInEditMode({commit}) {
    commit(types.SET_CARTED)
  },
  setGiftCardInput({commit}, payload) {
    commit(types.SET_INPUT, payload)
  },
  setLocalGiftCardCartItem({commit}, payload) {
    commit(types.SET_LOCAL_CART_ITEM, payload)
  },
  unsetLocalGiftCardCartItem({commit}, payload) {
    commit(types.UNSET_LOCAL_CART_ITEM, payload)
  },
  clearLocalGiftCardCart({commit}) {
    commit(types.CLEAR_LOCAL_CART_ITEMS)
  }
}

// getters
const getters = {
  giftCardPreviewing: state => state.previewMode,
  giftCardEditItem: state => state.editItem,
  isGiftCardInEditMode: state => !!state.giftCardEditItem,
  giftCardInput(state, getters) {
    return function (item) {
      if (!item) {
        return state.form
      }
      return state.form[item]
    }
  },
  availableGiftCards: state => state.products,
  selectedGiftCardId: state => state.form.productId || '',
  selectedGiftCard: (state, getters) => getters.availableGiftCards[getters.selectedGiftCardId] || {},
  giftCardPreviewHtml(state, getters) {
    const product = getters.selectedGiftCard
    if (!product) {
      return ''
    }
    const inputs = getters.giftCardInput()

    const data = {
      Amount: Number(product.value || 0).toFixed(0),
      Note: inputs.giftNote || '',
      'First Name': inputs.firstName || '',
      'Last Name': inputs.lastName || '',
      'Giftee First Name': inputs.gifteeFirstName || '',
      'Giftee Last Name': inputs.gifteeLastName || '',
      'Card Number': inputs.cardNumber || '#000 000 000 0000',
    }

    let template = giftCardEmail['template' + inputs.giftee || '']

    _.forOwn(data, (val, key) => {
      template = template.replace(new RegExp(`\\[\\[${key}\\]\\]`, 'g'), val)
    })

    template = template.replace(/(src=")\//g, '$1' + config.BASEURI + '/')

    return template

  },
  localGiftCardCartItems: state => state.cartItems,
  proposedGiftCardCart(state, getters) {
    return helpers.createCardItem(getters.giftCardInput(), state, getters)
  },
}

// plugins
const plugins = []

const giftcard = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default giftcard
